import { getLocaleFromLocaleEvaneos, LocaleEvaneos } from '../../../../core/i18n/Locale';
import { PickDomain } from '../../../../shared/utilities/types/PickDomain';
import { User } from '../../domain/types/User';

export type UserFromPyrite = {
    accountId: string;
    email: string;
    firstName: string;
    id: number;
    isEvaneos: boolean;
    isTcare: boolean;
    lastName: string;
    noPasswordToken: string | null;
    numberOfUserQuotesByStateCounters: {
        cancelled: number;
        confirmed: number;
        done: number;
        in_progress: number;
        planning: number;
    };
    phone: string;
    recommendationsIsEnabled: boolean;
    status: 'prospect' | 'wanderlust' | 'first timer experiencer' | 'repeater experiencer' | null;
    token: string;
    locale: LocaleEvaneos;
    communityMemberSince: string | null;
};

export type NormalizedUserFromPyrite = PickDomain<
    User,
    | 'accountId'
    | 'email'
    | 'firstName'
    | 'id'
    | 'isEvaneos'
    | 'isTcare'
    | 'lastName'
    | 'numberOfUserQuotesByStateCounters'
    | 'phone'
    | 'recommendationsIsEnabled'
    | 'token'
    | 'locale',
    {
        noPasswordToken: User['noPasswordToken'] | null;
        status: User['status'] | null;
        communityMemberSince: User['communityMemberSince'] | null;
    }
> | null;

export function normalizeUserFromPyrite(user: UserFromPyrite): NormalizedUserFromPyrite {
    if (user === null) {
        return null;
    }

    return {
        ...user,
        noPasswordToken: user.noPasswordToken ?? null,
        locale: getLocaleFromLocaleEvaneos(user.locale),
        communityMemberSince: user.communityMemberSince
            ? new Date(user.communityMemberSince)
            : null,
    };
}
